import "./Footer.css";
import logo from "../Assets/Amy.jpg"; 

function Footer() {
  return (
    <footer className="footer">
      <div className="footer-container">
        
        <div className="footer-about">
        <a href="/">
          <img src={logo} alt="Logo" className="footer-logo" />
          </a>
          <p>
            Amy Floris OPC Pvt Ltd is your trusted partner for BIS certification,
            offering expert guidance and comprehensive solutions for all your certification needs.
          </p>
        </div>

       
        <div className="footer-column">
          <h4>Follow Us</h4>
          <ul>
    <li>
      <a
        href="https://www.instagram.com/amy_floris_/"
        target="_blank"
        rel="noopener noreferrer"
      >
        Instagram
      </a>
    </li>
    <li>
      <a href="https://www.linkedin.com/company/amy-floris-services-opc-pvt-ltd" target="_blank" rel="noopener noreferrer">
        LinkedIn
      </a>
    </li>

    <li>
      <a href="https://www.facebook.com/people/Amy-Floris/61559172038501/" target="_blank" rel="noopener noreferrer">
        Facebook
      </a>
    </li>
  </ul>
        </div>

        <div className="footer-column">
          <h4>Services</h4>
          <ul>
            <li>BIS Certification Consulting</li>
            <li>Minimal Liquid Discharge</li>
            <li>Documentation Support</li>
            <li>Compliance Audits</li>
          </ul>
        </div>

        <div className="footer-column">
          <h4>Company</h4>
          <ul>
            <li>Privacy Policy</li>
            <li>Terms of Service</li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        © 2025 Amy Floris OPC Pvt Ltd. All rights reserved.
      </div>
    </footer>
  );
}

export default Footer;
